module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "part001"
    }
  }, [_c('h1', {
    staticClass: "part-number"
  }, [_c('a', {
    attrs: {
      "href": "#/toc#toc-part001"
    }
  }, [_vm._v("Book I")])]), _vm._v(" "), _c('h1', {
    staticClass: "part-title"
  }, [_c('a', {
    attrs: {
      "href": "#/toc#toc-part001"
    }
  }, [_vm._v("O Canada")])]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Some people call what we did “running away.” I call it “a strategic retreat before I started shooting motherfuckers in the head.” Isn’t that a nicer way to put things?")])]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—S"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("HAUN")]), _vm._v(" M"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ASON")])])]), _vm._v(" "), _c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("No matter how far we get from the people who made me what I am today, I’m still not sleeping. So I guess they won after all. Bully for them.")])]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("—G"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("EORGIA")]), _vm._v(" M"), _c('span', {
    staticClass: "small-caps"
  }, [_vm._v("ASON")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ba9a948","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part001.vue
// module id = 69
// module chunks = 0